import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

interface DialogComponentProps {
    open: boolean;
    header: string;
    body: string;
    onConfirm: () => void;
    onCancel: () => void;
    confirmText?: string;
    cancelText?: string;
}

const DialogComnponent: React.FC<DialogComponentProps> = ({
                                                             open,
                                                             header,
                                                             body,
                                                             onConfirm,
                                                             onCancel,
                                                             confirmText = "Fortsett",
                                                             cancelText = "Avbryt",
                                                               }) => {

    return (
        <main>
            <Dialog
                open={open}
                onClose={onCancel}
            >
                <DialogTitle>{header}</DialogTitle>

                <DialogContent>
                    <DialogContentText>{body}</DialogContentText>
                </DialogContent>

                <DialogActions sx={{ justifyContent: 'flex-start', px: 3, pb: 2, gap: 2 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onConfirm}
                    >
                        {confirmText}
                    </Button>

                    <Button
                        color="inherit"
                        onClick={onCancel}
                    >
                        {cancelText}
                    </Button>
                </DialogActions>
            </Dialog>
        </main>
    );
};
export default DialogComnponent;
